var DualRowPackageData = require('./dualRowPackageData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var EllipseData = require('../../../svg/ellipseData.js');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');

var OscillatorCornerConcaveData = function(position, angle, init) {
    DualRowPackageData.apply(this, arguments);

    //center gap between terminals at opposite sides
    this.horizontalTerminalGapMax = this.value("horizontalTerminalGapMax", true);
    this.horizontalTerminalGapMin = this.value("horizontalTerminalGapMin", true);
    this.verticalTerminalGapMax = this.value("verticalTerminalGapMax", true);
    this.verticalTerminalGapMin = this.value("verticalTerminalGapMin", true);

    //calculate terminal gap max/min for each dimension and pass it to component class to calculate pads size for that dimension
    this.terminalGapMax = 0;
    this.terminalGapMin = 0;

    this.nonTransformedSegmentedGeometry.addTrigger(this.horizontalTerminalGapMax);
    this.nonTransformedSegmentedGeometry.addTrigger(this.horizontalTerminalGapMin);
    this.nonTransformedSegmentedGeometry.addTrigger(this.verticalTerminalGapMax);
    this.nonTransformedSegmentedGeometry.addTrigger(this.verticalTerminalGapMin);
 
};

lib_core.inherit(OscillatorCornerConcaveData, DualRowPackageData);
lib_core.JsonParser.registerClass(OscillatorCornerConcaveData, "OscillatorCornerConcaveData");

module.exports = OscillatorCornerConcaveData;


OscillatorCornerConcaveData.prototype.setupMinMaxPtrMap = function() {
    DualRowPackageData.prototype.setupMinMaxPtrMap.call(this);
    this.minMaxPointerMap["horizontalTerminalGap"] = [this.horizontalTerminalGapMin, this.horizontalTerminalGapMax];
    this.minMaxPointerMap["varticalTerminalGap"] = [this.verticalTerminalGapMin, this.verticalTerminalGapMax];
    this.validationMap["horizontalTerminalGapMax"] = [this.horizontalTerminalGapMax];
    this.validationMap["verticalTerminalGapMax"] = [this.verticalTerminalGapMax];
};
/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
OscillatorCornerConcaveData.prototype.getPads = function(absolutePositions) {
    var self = this;
    var pads = [],
        padHeight, padWidth, hPitch, vPitch;

    //reset component
    self.component.reset();

    //for below calculation see wiki
    var horizontalLeadToLeadSpanAvg = (self.bodyWidthMax() + self.bodyWidthMin()) / 2;
    var verticalLeadToLeadSpanAvg = (self.bodyLengthMax() + self.bodyLengthMin()) / 2;

    if(verticalLeadToLeadSpanAvg < horizontalLeadToLeadSpanAvg) {
    	self.terminalGapMin = self.verticalTerminalGapMin();
    	self.terminalGapMax = self.verticalTerminalGapMax();

    	self.updateComponentCalculator(self.bodyLengthMin(), self.bodyLengthMax());

    	padHeight = self.component.X;
    	vPitch = self.component.C;
    } else {
    	self.terminalGapMin = self.horizontalTerminalGapMin();
    	self.terminalGapMax = self.horizontalTerminalGapMax();

    	self.updateComponentCalculator(self.bodyWidthMin(), self.bodyWidthMax());

    	padWidth = self.component.X;
    	hPitch = self.component.C;
    }

    //update terminal gap for other dimension (derived from other dimension's terminal gap)
    if(verticalLeadToLeadSpanAvg < horizontalLeadToLeadSpanAvg) {
    	self.terminalGapMax = self.horizontalTerminalGapMax();
    	self.terminalGapMin = self.horizontalTerminalGapMax() - (self.verticalTerminalGapMax() - self.verticalTerminalGapMin());

    	self.updateComponentCalculator(self.bodyWidthMin(), self.bodyWidthMax());

    	padWidth = self.component.X;
    	hPitch = self.component.C;
    } else {
    	self.terminalGapMax = self.verticalTerminalGapMax();
    	self.terminalGapMin = self.verticalTerminalGapMax() - (self.horizontalTerminalGapMax() - self.horizontalTerminalGapMin());

    	self.updateComponentCalculator(self.bodyLengthMin(), self.bodyLengthMax());

    	padHeight = self.component.X;
    	vPitch = self.component.C;
    }

    //Note: Pad should be calculated in anti-clockwise direction [left, down, right, up] for quad packages and [left and right] for rest of the packages.
    //The order is important to apply proper pad name from the generated namelist. Do not change the order otherwise pad's name would be incorrect.
    var i, nRow = self.component.padsPerSide[0],
        motif = self.getMotif();

    self.updateMotif(motif, padWidth, padHeight);

    //add 4 pads
    var pad = motif.clone();
    pad.move(new lib_geometry.Coord(-0.5 * hPitch, -0.5 * vPitch));
    pads.push(pad);

    pad = motif.clone();
    pad.move(new lib_geometry.Coord(0.5 * hPitch, -0.5 * vPitch));
    pads.push(pad);

    pad = motif.clone();
    pad.move(new lib_geometry.Coord(0.5 * hPitch, 0.5 * vPitch));
    pads.push(pad);

    pad = motif.clone();
    pad.move(new lib_geometry.Coord(-0.5 * hPitch, 0.5 * vPitch));
    pads.push(pad);

    self.updatePads(pads, absolutePositions);

    return pads;
};

/**
 * Calculate silkscreen for selected component. Silkscreen is calculated from body and pads geometry.
 * @param  {array} pads Pads calculated from getPads() function.
 * @return {array} Array of silkscreen data (LineData)
 */
OscillatorCornerConcaveData.prototype.getSilkscreen = function(pads) {
    var self = this;
    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    //TODO-CHECK: if number of pads in left side is less than 1 dont draw silkscreen
    if (self.component.padsPerSide[0] < 1) return silkscreen;

    //get body dimesnsions depending on mapping type of silkscreen to body
    var body = self.getBodyForSilkscreen();

    ////////////////////
    //   Pin Marker   //
    ////////////////////

    silkscreen.push(this.getPinOneMarker(pads[0], body, true));

    //////////////////////////////
    //   Component Silkscreen   //
    //////////////////////////////
    //left
    var pathData = new PathData(new lib_geometry.Coord(pads[3].getPos().x - pads[3].getTopCopper().width() / 2 - IPCRules.silkscreenStrokeWidth / 2, pads[3].getPos().y - pads[3].getTopCopper().height() / 2 - IPCRules.silkscreenClearance), IPCRules.silkscreenStrokeWidth);
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(pads[0].getPos().x - pads[0].getTopCopper().width() / 2 - IPCRules.silkscreenStrokeWidth / 2, pads[0].getPos().y + pads[0].getTopCopper().height() / 2 + IPCRules.silkscreenClearance), PathType.LINE));
    silkscreen.push(pathData);

    //right
    pathData = pathData.clone();
    pathData.flip(new lib_geometry.Line(lib_geometry.Line.VER, new lib_geometry.Coord(0, 0)));
    silkscreen.push(pathData);

    //top
    pathData = new PathData(new lib_geometry.Coord(pads[3].getPos().x + pads[3].getTopCopper().width() / 2 + IPCRules.silkscreenClearance, pads[3].getPos().y + pads[3].getTopCopper().height() / 2 + IPCRules.silkscreenStrokeWidth / 2), IPCRules.silkscreenStrokeWidth);
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(pads[2].getPos().x - pads[2].getTopCopper().width() / 2 - IPCRules.silkscreenClearance, pads[2].getPos().y + pads[2].getTopCopper().height() / 2 + IPCRules.silkscreenStrokeWidth / 2), PathType.LINE));
    silkscreen.push(pathData);

    //bottom
    pathData = pathData.clone();
    pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
    silkscreen.push(pathData);

    return silkscreen;
};
